import { Pipe, PipeTransform } from '@angular/core';
import { getDuration } from 'src/app/utils/date.utils';

@Pipe({
    name: 'duration',
    standalone: false
})
export class DurationPipe implements PipeTransform {

  transform(value: string, withMonth = true): string {
      return getDuration(value, withMonth);
  }

}
